import { NavLink, Link } from 'react-router-dom';
import { NAV_ITEMS, ADMIN_NAV_ITEM } from '../config/nav';
import { UserMenu } from './UserMenu';
import { useAuth } from '../contexts/AuthContext';

export function TopNav() {
  const { user, status } = useAuth();
  const isGuest = status === 'guest';
  const items = isGuest
    ? NAV_ITEMS.filter(i => i.to === '/spots')
    : (user?.isSuperAdmin ? [...NAV_ITEMS, ADMIN_NAV_ITEM] : NAV_ITEMS);
  return (
    <nav className="hidden md:flex items-center border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 px-6">
      <div className="flex-1 flex items-center gap-1">
        {items.map(i => (
          <NavLink
            key={i.to}
            to={i.to}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
                isActive
                  ? 'border-teal-600 text-teal-600 dark:border-teal-400 dark:text-teal-400'
                  : 'border-transparent text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100'
              }`
            }
          >
            <span className="w-5 h-5 inline-flex items-center justify-center [&_svg]:w-5 [&_svg]:h-5">
              {i.icon}
            </span>
            {i.label}
          </NavLink>
        ))}
      </div>
      {isGuest ? (
        <Link
          to="/login"
          className="rounded-lg bg-teal-600 dark:bg-teal-500 px-4 py-2 text-sm font-semibold text-white hover:bg-teal-700 dark:hover:bg-teal-600 transition-colors"
        >
          Sign in
        </Link>
      ) : (
        <UserMenu align="right" />
      )}
    </nav>
  );
}
